import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginPage from './app/pages/guest/LoginPage';
import ForgottenPasswordPage from './app/pages/guest/ForgottenPasswordPage';
import DashboardPage from './app/pages/auth/DashboardPage';
import CategoryPage from './app/pages/auth/CategoryPage';
import LecturePage from './app/pages/auth/LecturePage';
import UserSettingsPage from './app/pages/auth/UserSettingsPage';
import ResetPasswordPage from './app/pages/guest/ResetPasswordPage.tsx';
import SignUpPage from './app/pages/guest/SignUpPage.tsx';
import InstitutionSettingsPage from './app/pages/auth/InstitutionSettingsPage.tsx';
import BuyLicensePage from './app/pages/auth/BuyLicensePage.tsx';
import SelectLicensePage from './app/pages/auth/SelectLicensePage.tsx';
import TryLicensePage from './app/pages/auth/TryLicensePage.tsx';
import SignUpPageB from './app/pages/guest/SignUpPageB.tsx';
import AcceptInvitationPage from './app/pages/guest/AcceptInvitationPage.tsx';
import OnboardingPage from './app/pages/guest/OnboardingPage.tsx';

Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    dsn: 'https://94698403729ba9bd8c6f1dd923c4b761@o4508059832811520.ingest.de.sentry.io/4508059835236432',
    integrations: [],
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                {/* GUEST */}
                <Route path="/" element={<LoginPage />} />
                <Route path="/registrace" element={<SignUpPage />} />
                <Route path="/registrace-1" element={<SignUpPageB />} />
                <Route path="/pozvanka" element={<AcceptInvitationPage />} />
                <Route path="/onboarding" element={<OnboardingPage />} />
                <Route
                    path="/zapomenute-heslo"
                    element={<ForgottenPasswordPage />}
                />
                <Route
                    path="/reset-hesla/:token"
                    element={<ResetPasswordPage />}
                />
                {/* AUTH */}
                <Route
                    path="/nastaveni-instituce"
                    element={<InstitutionSettingsPage />}
                />
                <Route path="/nastaveni" element={<UserSettingsPage />} />
                <Route path="/koupit" element={<SelectLicensePage />} />
                <Route path="/koupit/plna-verze" element={<BuyLicensePage />} />
                <Route path="/koupit/zkusebni-verze" element={<TryLicensePage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/cviceni/:category?" element={<CategoryPage />} />
                <Route
                    path="/cviceni/lekce/:subCategory"
                    element={<LecturePage />}
                />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
